<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem'

defineProps<{
  title: string
  description?: string
}>()

const { t } = useI18n()

const items = useBreadcrumbItems({ overrides: [
  {
    label: t('Home'),
    icon: 'tabler:home',
  },
] })
</script>

<template>
  <div class="flex flex-col gap-1 my-4">
    <Breadcrumb
      :model="items as MenuItem[]"
      class="bg-transparent! px-0 py-0 text-sm"
    >
      <template #item="{ item, props }">
        <NuxtLink
          class="p-breadcrumb-item-link"
          :to="item.to"
          v-bind="props"
        >
          <span
            v-if="item.icon"
            class="p-breadcrumb-item-icon items-center flex"
          >
            <Icon :name="item.icon" />
          </span>
          <span class="p-breadcrumb-item-label">
            {{ item.label }}
          </span>
        </NuxtLink>
      </template>
    </Breadcrumb>
    <div class="flex items-start flex-col lg:justify-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-surface-900 dark:text-surface-0 items-center">
          {{ title }}
        </div>
        <div
          v-if="description || $slots.description"
          class="flex items-center text-surface-700 dark:text-surface-100 flex-wrap"
        >
          <div class="mr-8 flex items-center mt-4">
            <slot name="description" />
            <span>{{ description }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
